import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAsoodeh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={60}
    height={61}
    fill='none'
    {...props}
  >
    <rect width={60} height={60} y={0.5} fill='url(#Asoodeh_svg__a)' rx={8} />
    <defs>
      <pattern id='Asoodeh_svg__a' width={1} height={1} patternContentUnits='objectBoundingBox'>
        <use xlinkHref='#Asoodeh_svg__b' transform='scale(.00324)' />
      </pattern>
      <image
        xlinkHref='/images/icons/asoodeh-ead1695d.webp'
        id='Asoodeh_svg__b'
        width={309}
        height={309}
        preserveAspectRatio='none'
      />
    </defs>
  </svg>
);
export default SvgAsoodeh;
